import React from 'react';
import './Footer.css';
import IconButton from '@mui/material/IconButton';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import { Link } from 'react-router-dom';


const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <p>Atomic Tattoo Removal</p>
      <p>78 South St #201, Wrentham MA  02093</p>
      <p>Phone: (508) 203-1342</p>
      <p style={{ fontSize: '0.85em', marginTop: '8px', maxWidth: '600px', margin: '8px auto 0', color: '#555' }}>
        By contacting us or opting in on our intake form, you agree to receive service-related SMS messages, including appointment reminders. Message & data rates may apply. Reply STOP to opt out. See our{' '}
        <Link to="/privacy-policy" style={{ color: '#333', textDecoration: 'underline' }}>Privacy Policy</Link>
        {' '}and{' '}
        <Link to="/terms-and-conditions" style={{ color: '#333', textDecoration: 'underline' }}>Terms</Link>.
      </p>
      <p>
        <Link to="/privacy-policy" style={{ color: '#333', textDecoration: 'underline' }}>Privacy Policy</Link>
        {' | '}
        <Link to="/terms-and-conditions" style={{ color: '#333', textDecoration: 'underline' }}>Terms and Conditions</Link>
      </p>
      <div className="social-media">
        <IconButton
          component="a"
          href="https://www.facebook.com/profile.php?id=61576465160471"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Facebook"
        >
          <FacebookIcon />
        </IconButton>
        <IconButton
          component={Link} // Use Link for routing
          to="/instagram" // Route to the Instagram page
          aria-label="Instagram"
        >
          <InstagramIcon />
        </IconButton>
      </div>
    </footer>
  );
};

export default Footer;